var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefactorWhite = function SvgBenefactorWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.5,
    r: 8,
    stroke: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F5",
    stroke: "#F2F3F5",
    strokeWidth: 1.526,
    d: "M9 10.389a1.065 1.065 0 0 0-1.336-.553A1.065 1.065 0 0 0 7.111 8.5c.503-.23.747-.818.553-1.336A1.065 1.065 0 0 0 9 6.611c.23.503.818.747 1.335.553-.193.518.05 1.107.554 1.336-.503.23-.747.818-.553 1.336A1.065 1.065 0 0 0 9 10.389Z"
  })));
};
export default SvgBenefactorWhite;